<template>
  <div class="feed-item">
    <div class="body-wrapper">
      <div class="feed-content">
        <FeedHeader :feed="feed" :scene="feedScene" />
        <div class="feed-summary">{{ cutOutContent }}</div>
        <div class="link-wrapper">
          <a href="javascript:;" @click="viewDetail">查看详情</a>
        </div>
        <ArticleElement
          v-if="feed.article === FEED_TYPES.ARTICLE"
          :feed="feed"
        />
        <AlbumElement v-if="feed.article === FEED_TYPES.ALBUM" :feed="feed" />
        <AudioElement v-if="feed.article === FEED_TYPES.AUDIO" :feed="feed" />
        <VideoElement v-if="feed.article === FEED_TYPES.VIDEO" :feed="feed" />
      </div>
    </div>
    <div class="footer-wrapper">
      <FeedFooter :feed="feed" :scene="feedScene" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import FeedFooter from "../../friend/feed-footer";
import ArticleElement from "../../friend/feed-elements/article-element";
import AlbumElement from "../../friend/feed-elements/album-element";
import AudioElement from "../../friend/feed-elements/audio-element";
import VideoElement from "../../friend/feed-elements/video-element";
import { sliceFeedContent } from "../../../utils/feed";
import FeedHeader from "./feed-header";
export default {
  name: "feed-item",
  data() {
    return {
      feedScene: "feedList",
    };
  },
  props: {
    feed: {
      type: Object,
      required: true,
    },
    page: Number,
  },
  components: {
    FeedHeader,
    FeedFooter,
    ArticleElement,
    AlbumElement,
    AudioElement,
    VideoElement,
  },
  computed: {
    cutOutContent() {
      return sliceFeedContent(this.feed.content);
    },
    initDetailLink() {
      return `/detail?feedID=${this.feed.modelId}&feedType=${this.feed.article}`;
    },
  },
  methods: {
    viewDetail() {
      // console.log(document.documentElement.scrollTop)
      const initUserSign = {
        feedPage: this.page,
        articlePage: 1,
        albumPage: 1,
        audioPage: 1,
        videoPage: 1,
      };
      Store.dispatch("setUserCenterSign", initUserSign);
      // this.$router.push({
      //   path: "detail",
      //   query: { feedID: this.feed.modelId, feedType: this.feed.article },
      // });
      let routerClanCard = this.$router.resolve({
        path: "detail",
        query: { feedID: this.feed.modelId, feedType: this.feed.article },
      });
      window.open(routerClanCard.href, "_blank");
    },
  },
};
</script>
<style scoped>
.feed-item {
  margin-bottom: 15px;
  padding: 15px;
  background-color: #fff;
}

.feed-summary {
  width: 750px;
  line-height: 25px;
  font-size: 16px;
  white-space: pre-wrap;
}

.link-wrapper a {
  color: #1a70db;
}
</style>